module.exports = __webpack_public_path__ + "static/media/savgun_logo.2fbc9081.png";